import { createContext } from "react";
import { SearchResult } from "#next/utils/interfaces";
import { TExplorerHighlightText, TTimeRanges } from "#next/utils/shared";

export type FeedActionPrefix =
  | "Explorer"
  | "User Search"
  | "Preview"
  | "Single Post"
  | "Post Modal";

export type PostContext = {
  wordLimit: number;
  trackActionPrefix: FeedActionPrefix | null;
  posts: SearchResult[];
  originalSearchResults: SearchResult[];
  onSelectPost: (post: SearchResult) => void;
  timeRange: TTimeRanges;
  textHighlights: TExplorerHighlightText[];
  translateAll: boolean;
  blurMedia: boolean;
  hideButtons: boolean;
  enableUserPreview: boolean;
  displayRelevance: boolean;
};

export const PostContext = createContext<PostContext>({
  wordLimit: NaN,
  trackActionPrefix: null,
  posts: [],
  originalSearchResults: [],
  onSelectPost: () => {
    throw new Error("Context defaults don't do anything");
  },
  timeRange: "Last 180 days",
  textHighlights: [],
  translateAll: false,
  blurMedia: false,
  hideButtons: false,
  enableUserPreview: false,
  displayRelevance: true,
});
